import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App"; // <-- default import (no curly braces)
import "./styles.css"; // optional if you have it

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
